import * as d3 from 'd3'
export default {
  
  methods: {

    tbl_Handover() {

      this.tableCanvas = this.svg
      .append('g')
      .attr('transform', `translate(${this.handover.x}, ${this.handover.y})`)

      this.tableCanvas
      .append('text')
      .attr('x', 0).attr('y', 0)
      .attr('font-size', 13).attr('fill', '#000')
      .text('PRIMARY SYSTEMS')

      let y_ = 5
      this.rawData.forEach(d=> {

        this.gmx_Line(this.tableCanvas, 0, this.handover.width, y_, y_, '#E0E0DF', .5, 3)

        let handover = this.tableCanvas
        .append('g')
        .attr('transform', `translate(0, 0)`)
        .attr('cursor', 'pointer')
        .call(this.call_Handover, d.SYS_CODE)

        handover
        .append('rect')
        .attr('id', `HANDOVER_${d.SYS_CODE}`)
        .attr('x', 0).attr('y', y_+1)
        .attr('width', this.handover.width).attr('height', this.handover.lineHeight-2)
        .attr('fill', '#F4F5F5')
        .attr('opacity', this.current.group == d.SYS_CODE ? .6: 0)

        handover
        .append('text')
        .attr('x', 167).attr('y', y_ + 37)
        .attr('font-size', 11).attr('fill', '#333').attr('text-anchor', 'end')
        .text(`${d.DESC}`)

        handover
        .append('text')
        .attr('x', 190).attr('y', y_ + 37)
        .attr('font-size', 11).attr('fill', '#44A9DF').attr('text-anchor', 'end')
        .text(`(${d.SYS_CODE})`)
        
        this.handover.cols.forEach(col=> {
          this.draw_Handover_Table(handover, col, d, y_)
        })

        y_ += this.handover.lineHeight
      })
      this.gmx_Line(this.tableCanvas, 0, this.handover.width, y_, y_, '#E0E0DF', .5, 1)
    },
    

    draw_Handover_Table(selection, col, data_, y_) {

      let pro = data_[`${col.code}_PRO`]
      let proLen = (data_[`${col.code}_PRO`]/100) * 130

      let status = selection
      .append('g')
      .attr('transform', `translate(0, ${y_ + col.y})`)
      
      status
      .append('text')
      .attr('x', 260).attr('y',  0)
      .attr('font-size', 10).attr('fill', '#757575').attr('text-anchor', 'end')
      .text(col.name)

      status
      .append('text')
      .attr('x', 310).attr('y', 0)
      .attr('font-size', 10).attr('fill', data_[`${col.code}_TOT`] == 0 ? '#bcbcbc' : '#000').attr('text-anchor', 'end')
      .text(data_[`${col.code}_TOT`])
      .call(this.event_Link, data_ , col)

      status
      .append('rect')
      .attr('x', 315).attr('y', -8.5).attr('ry', 5)
      .attr('width', 130).attr('height', 11)
      .attr('fill', '#F4F5F5')
      .attr('opacity', data_[`${col.code}_TOT`] == 0 ? .3 : 1)

      status
      .append('rect')
      .attr('x', 315).attr('y', -8.5).attr('ry', 5)
      .attr('width', proLen).attr('height', 11)
      .attr('fill', col.color)

      let text_ = status
        .append('text')
        .attr('x', pro < 60 ? 315 + proLen + 1 : 315 + proLen - 1)
        .attr('y', 0)
        .attr('font-size', 10)
        .attr('fill', '#757575')
        .attr('text-anchor', pro < 60 ? 'start' : 'end')
        .text(pro + '%');
          
      // if (col.code == 'PB') {
      //   text_.call(this.event_Link, data_, col, '', 'ACT');
      // }

      
      // status
      // .append('text')
      // .attr('x', pro<60 ? 315 + proLen+1 : 315 + proLen-1).attr('y', 0)
      // .attr('font-size', 10).attr('fill', '#757575')
      // .attr('text-anchor', pro<60 ? 'start' : 'end')
      // .text(col.code == 'PA' ? data_[`${col.code}_ACT`] : pro + '%')
      // .call(this.event_Link, data_ , col)

      status
      .append('text')
      .attr('x', 448).attr('y', 0)
      .attr('font-size', 10).attr('fill', data_[`${col.code}_REM`] == 0 ? '#bcbcbc' : '#000')
      .text(data_[`${col.code}_REM`])
      .call(this.event_Link, data_ , col, '', 'REM')

    }

  }
}